import React, { useState } from 'react';
import { Table } from "@tanstack/react-table";
import { CSVService } from "@/services/CSVService";
import { CSVLink } from "react-csv";
import { cn } from '@/lib/utils';
import { Button, buttonVariants } from '../components/ui/button';
import { Loader2 } from 'lucide-react';

interface Props<TData> {
    table: Table<TData>;
}

export default function ExportButton<TData>({ table }: Props<TData>) {
    const [loading, setLoading] = useState(false);
    const csvService = new CSVService();

    const exportCSV = () => {
        // TODO: Subject to change as we add other table paraphenalia
        const data = table.getFilteredRowModel().rows.map((item) => item.original);
        const formattedData = csvService.biddersToCSV(data);
        return formattedData;
    };

    return (
        <>
            <CSVLink
                data={exportCSV()}
                headers={csvService.BidderHeaders}
                filename={`bidders.csv`}
                className={cn(buttonVariants({ variant: "outline" }))}
                target="_blank"
                suppressHydrationWarning
                onClick={() => {
                    setLoading(true);
                    // Return a promise that resolves after a short delay
                    return new Promise<boolean>((resolve) => {
                        setTimeout(() => {
                            setLoading(false);
                            resolve(true); // true to proceed with download
                        }, 100);
                    });
                }}
                asyncOnClick={true}
            >
                {loading ? (
                    <>
                        <Loader2 className="w-4 h-4 animate-spin mr-2" />
                        Exporting...
                    </>
                ) : (
                    "Export"
                )}
            </CSVLink>
        </>
    );
};